/**
 * The Rewards Hub's art — referenced through the bundler (08.10). Each file is emitted under
 * /_next/static/media with its content hash in the name and served
 * `immutable`: a browser fetches it once, until the file changes, which
 * changes its URL. `new URL(…, import.meta.url)` carries only the URL (an
 * image import would also inline a blur placeholder per file), and every file
 * is listed because the bundler ships only what it can see.
 */

export const REWARDS_ART = {
  'achievements-empty.webp': new URL('./achievements-empty.webp', import.meta.url).href,
  'artifact-tip-cup-glow.svg': new URL('./artifact-tip-cup-glow.svg', import.meta.url).href,
  'artifact-tip-cup-ground.svg': new URL('./artifact-tip-cup-ground.svg', import.meta.url).href,
  'artifact-tip-diamond-glow.svg': new URL('./artifact-tip-diamond-glow.svg', import.meta.url).href,
  'artifact-tip-diamond-ground.svg': new URL('./artifact-tip-diamond-ground.svg', import.meta.url)
    .href,
  'artifact-tip-medal-glow.svg': new URL('./artifact-tip-medal-glow.svg', import.meta.url).href,
  'artifact-tip-medal-ground.svg': new URL('./artifact-tip-medal-ground.svg', import.meta.url).href,
  'avatar-sparkle-1.svg': new URL('./avatar-sparkle-1.svg', import.meta.url).href,
  'avatar-sparkle-2.svg': new URL('./avatar-sparkle-2.svg', import.meta.url).href,
  'avatar-sparkle-3.svg': new URL('./avatar-sparkle-3.svg', import.meta.url).href,
  'avatar-wreath.webp': new URL('./avatar-wreath.webp', import.meta.url).href,
  'avatars-preview.webp': new URL('./avatars-preview.webp', import.meta.url).href,
  'badge-frame-gold.webp': new URL('./badge-frame-gold.webp', import.meta.url).href,
  'badge-frame-ice.webp': new URL('./badge-frame-ice.webp', import.meta.url).href,
  'badge-frame-onyx.webp': new URL('./badge-frame-onyx.webp', import.meta.url).href,
  'badge-frame-royal.webp': new URL('./badge-frame-royal.webp', import.meta.url).href,
  'badge-frame-seasonal.webp': new URL('./badge-frame-seasonal.webp', import.meta.url).href,
  'badge-frame-silver.webp': new URL('./badge-frame-silver.webp', import.meta.url).href,
  'badge-glyph.webp': new URL('./badge-glyph.webp', import.meta.url).href,
  'coin.webp': new URL('./coin.webp', import.meta.url).href,
  'collection-hint-book.webp': new URL('./collection-hint-book.webp', import.meta.url).href,
  'cup.webp': new URL('./cup.webp', import.meta.url).href,
  'daily-back-blue-face.webp': new URL('./daily-back-blue-face.webp', import.meta.url).href,
  'daily-back-blue.webp': new URL('./daily-back-blue.webp', import.meta.url).href,
  'daily-back-grey-face.webp': new URL('./daily-back-grey-face.webp', import.meta.url).href,
  'daily-back-grey.webp': new URL('./daily-back-grey.webp', import.meta.url).href,
  'daily-gold-a.webp': new URL('./daily-gold-a.webp', import.meta.url).href,
  'daily-gold-face.webp': new URL('./daily-gold-face.webp', import.meta.url).href,
  'daily-ribbon-band.webp': new URL('./daily-ribbon-band.webp', import.meta.url).href,
  'daily-ribbon-tail.webp': new URL('./daily-ribbon-tail.webp', import.meta.url).href,
  'daily-today-a.webp': new URL('./daily-today-a.webp', import.meta.url).href,
  'daily-today-b.webp': new URL('./daily-today-b.webp', import.meta.url).href,
  'daily-today-face.webp': new URL('./daily-today-face.webp', import.meta.url).href,
  'diamond.webp': new URL('./diamond.webp', import.meta.url).href,
  'hero-chest.webp': new URL('./hero-chest.webp', import.meta.url).href,
  'hero-gift-intro-120.webm': new URL('./hero-gift-intro-120.webm', import.meta.url).href,
  'hero-gift-intro-60.webm': new URL('./hero-gift-intro-60.webm', import.meta.url).href,
  'hero-gift-loop-120.webm': new URL('./hero-gift-loop-120.webm', import.meta.url).href,
  'hero-gift-loop-60.webm': new URL('./hero-gift-loop-60.webm', import.meta.url).href,
  'hero-gift-poster.webp': new URL('./hero-gift-poster.webp', import.meta.url).href,
  'hero-title-line.webp': new URL('./hero-title-line.webp', import.meta.url).href,
  'hiw-connector.webp': new URL('./hiw-connector.webp', import.meta.url).href,
  'hiw-step1.webp': new URL('./hiw-step1.webp', import.meta.url).href,
  'hiw-step2.webp': new URL('./hiw-step2.webp', import.meta.url).href,
  'hiw-step3.webp': new URL('./hiw-step3.webp', import.meta.url).href,
  'leaderboard-card-glow-light.svg': new URL('./leaderboard-card-glow-light.svg', import.meta.url)
    .href,
  'leaderboard-card-glow.svg': new URL('./leaderboard-card-glow.svg', import.meta.url).href,
  'leaderboard-medal-best-deal.webp': new URL('./leaderboard-medal-best-deal.webp', import.meta.url)
    .href,
  'leaderboard-medal-roe.webp': new URL('./leaderboard-medal-roe.webp', import.meta.url).href,
  'leaderboard-medal-tasks.webp': new URL('./leaderboard-medal-tasks.webp', import.meta.url).href,
  'leaderboard-medal-trades.webp': new URL('./leaderboard-medal-trades.webp', import.meta.url).href,
  'leaderboard-medal-volume.webp': new URL('./leaderboard-medal-volume.webp', import.meta.url).href,
  'leaderboard-podium-intro-120.webm': new URL(
    './leaderboard-podium-intro-120.webm',
    import.meta.url,
  ).href,
  'leaderboard-podium-intro-60.webm': new URL('./leaderboard-podium-intro-60.webm', import.meta.url)
    .href,
  'leaderboard-podium-loop-120.webm': new URL('./leaderboard-podium-loop-120.webm', import.meta.url)
    .href,
  'leaderboard-podium-loop-60.webm': new URL('./leaderboard-podium-loop-60.webm', import.meta.url)
    .href,
  'leaderboard-podium-poster.webp': new URL('./leaderboard-podium-poster.webp', import.meta.url)
    .href,
  'leaderboard-podium.webp': new URL('./leaderboard-podium.webp', import.meta.url).href,
  'leaderboard-prize-illustration.svg': new URL(
    './leaderboard-prize-illustration.svg',
    import.meta.url,
  ).href,
  'leaderboard-wreath.webp': new URL('./leaderboard-wreath.webp', import.meta.url).href,
  'lock-gold.svg': new URL('./lock-gold.svg', import.meta.url).href,
  'lock-grey.svg': new URL('./lock-grey.svg', import.meta.url).href,
  'lock-rank.svg': new URL('./lock-rank.svg', import.meta.url).href,
  'medal.webp': new URL('./medal.webp', import.meta.url).href,
  'nav-gift.webp': new URL('./nav-gift.webp', import.meta.url).href,
  'nav-hover-glow.svg': new URL('./nav-hover-glow.svg', import.meta.url).href,
  'pick-banner-rare.webp': new URL('./pick-banner-rare.webp', import.meta.url).href,
  'pick-banner.webp': new URL('./pick-banner.webp', import.meta.url).href,
  'pick-card-back-rare.webp': new URL('./pick-card-back-rare.webp', import.meta.url).href,
  'pick-card-back.webp': new URL('./pick-card-back.webp', import.meta.url).href,
  'quest-card-texture.webp': new URL('./quest-card-texture.webp', import.meta.url).href,
  'quests/expert-bar.webp': new URL('./quests/expert-bar.webp', import.meta.url).href,
  'quests/glyphs/app-promo-redeem.webp': new URL(
    './quests/glyphs/app-promo-redeem.webp',
    import.meta.url,
  ).href,
  'quests/glyphs/first-closed-deal.webp': new URL(
    './quests/glyphs/first-closed-deal.webp',
    import.meta.url,
  ).href,
  'quests/glyphs/first-deposit.webp': new URL('./quests/glyphs/first-deposit.webp', import.meta.url)
    .href,
  'quests/glyphs/first-limit-order.webp': new URL(
    './quests/glyphs/first-limit-order.webp',
    import.meta.url,
  ).href,
  'quests/glyphs/first-order.webp': new URL('./quests/glyphs/first-order.webp', import.meta.url)
    .href,
  'quests/glyphs/set-tp-sl.webp': new URL('./quests/glyphs/set-tp-sl.webp', import.meta.url).href,
  'quests/lock-advanced.webp': new URL('./quests/lock-advanced.webp', import.meta.url).href,
  'quests/lock-basic.webp': new URL('./quests/lock-basic.webp', import.meta.url).href,
  'quests/lock-expert.webp': new URL('./quests/lock-expert.webp', import.meta.url).href,
  'quests/lock-oracle.webp': new URL('./quests/lock-oracle.webp', import.meta.url).href,
  'quests/lock-seasonal.webp': new URL('./quests/lock-seasonal.webp', import.meta.url).href,
  'quests/lock-unique.webp': new URL('./quests/lock-unique.webp', import.meta.url).href,
  'quests/oracle-corner.webp': new URL('./quests/oracle-corner.webp', import.meta.url).href,
  'quests/reward-chest.webp': new URL('./quests/reward-chest.webp', import.meta.url).href,
  'rank-1.webp': new URL('./rank-1.webp', import.meta.url).href,
  'rank-2.webp': new URL('./rank-2.webp', import.meta.url).href,
  'rank-3.webp': new URL('./rank-3.webp', import.meta.url).href,
  'rank-4.webp': new URL('./rank-4.webp', import.meta.url).href,
  'rank-5.webp': new URL('./rank-5.webp', import.meta.url).href,
  'rank-6.webp': new URL('./rank-6.webp', import.meta.url).href,
  'rank-check.svg': new URL('./rank-check.svg', import.meta.url).href,
  'rank-connector.svg': new URL('./rank-connector.svg', import.meta.url).href,
  'rank-reward-promo.webp': new URL('./rank-reward-promo.webp', import.meta.url).href,
  'rank-sparkle.svg': new URL('./rank-sparkle.svg', import.meta.url).href,
  'ranks-particles.webp': new URL('./ranks-particles.webp', import.meta.url).href,
  'ranks-smoke.webp': new URL('./ranks-smoke.webp', import.meta.url).href,
  'ranks-unlock-bar.webp': new URL('./ranks-unlock-bar.webp', import.meta.url).href,
  'reward-ticket.webp': new URL('./reward-ticket.webp', import.meta.url).href,
  'sparkle.webp': new URL('./sparkle.webp', import.meta.url).href,
} as const;

export type RewardsArtPath = keyof typeof REWARDS_ART;

/** Each rank's own art, rank 1 first — the fallback when the service sends none. */
export const RANK_ART: readonly string[] = [
  REWARDS_ART['rank-1.webp'],
  REWARDS_ART['rank-2.webp'],
  REWARDS_ART['rank-3.webp'],
  REWARDS_ART['rank-4.webp'],
  REWARDS_ART['rank-5.webp'],
  REWARDS_ART['rank-6.webp'],
];
